/**
 * Shared click-URL injection used by Rich/Static (`ClickUrlsRetriever`) and
 * Meta DSP (via a Meta-DSP-specific wrapper that adds BidCore guards).
 *
 * Injects `landingUrl` into `clickTrackerUrl`:
 * - last query param empty → set that param;
 * - otherwise → append encoded landing on the pathname.
 */
export function buildChainedClickUrl(
  landingUrl: string,
  clickTrackerUrl: string
): string {
  const parsed = new URL(clickTrackerUrl);
  const searchParams = parsed.searchParams;

  const keys: string[] = [];
  searchParams.forEach(function(_, key) {
    keys.push(key);
  });

  if (keys.length > 0) {
    const lastKey = keys[keys.length - 1];
    const lastValue = searchParams.get(lastKey);

    if (lastValue === '' || lastValue === null) {
      searchParams.set(lastKey, landingUrl);
      parsed.search = searchParams.toString();
      return parsed.toString();
    }
  }

  if (parsed.pathname.indexOf('/', parsed.pathname.length - 1) === -1) {
    parsed.pathname += '/';
  }
  parsed.pathname += encodeURIComponent(landingUrl);

  return parsed.toString();
}
